import { LitElement, html, nothing } from 'lit';

class BackInStockButton extends LitElement {
  static get properties() {
    return {
      loading: { type: Boolean, state: true },
      product: { type: Object, attribute: 'product' },
      variant_id: { type: String, attribute: 'variant-id' },
    };
  }

  async connectedCallback() {
    super.connectedCallback();

    // this.addEventListener('click', this.handleClick);
  }

  async handleClick() {
    const modalBackInStockEvent = new CustomEvent(`modal-back-in-stock:open`, { detail: { product: this.product, variant_id: this.variant_id } });
    document.dispatchEvent(modalBackInStockEvent);
  }

  createRenderRoot() {
    return this;
  }

  render() {
    return html`<button class="btn btn-primary product__add-to-cart d-block w-100" ?disabled=${this.loading} @click=${this.handleClick}>
    ${this.loading
      ? html`<bouncing-ellipsis></bouncing-ellipsis>`
      : window.theme.strings.back_in_stock.button}
    </button>`;
  }
}

window.customElements.get('back-in-stock-button') || window.customElements.define('back-in-stock-button', BackInStockButton);